module.exports = __webpack_public_path__ + "img/billink.3e8727da.svg";